'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const attrs = require('./attrs.js');
const contains = require('./contains.js');
const createScope = require('./create-scope.js');
const env = require('./env.js');
const getActiveElement = require('./get-active-element.js');
const getById = require('./get-by-id.js');
const getByText = require('./get-by-text.js');
const getByTypeahead = require('./get-by-typeahead.js');
const getComputedStyle = require('./get-computed-style.js');
const getEventTarget = require('./get-event-target.js');
const getScrollParent = require('./get-scroll-parent.js');
const isEditableElement = require('./is-editable-element.js');
const isHtmlElement = require('./is-html-element.js');
const platform = require('./platform.js');
const query = require('./query.js');
const raf = require('./raf.js');

const MAX_Z_INDEX = 2147483647;

exports.ariaAttr = attrs.ariaAttr;
exports.dataAttr = attrs.dataAttr;
exports.contains = contains.contains;
exports.isSelfEvent = contains.isSelfEvent;
exports.createScope = createScope.createScope;
exports.getDocument = env.getDocument;
exports.getWindow = env.getWindow;
exports.getActiveElement = getActiveElement.getActiveElement;
exports.indexOfId = getById.indexOfId;
exports.itemById = getById.itemById;
exports.nextById = getById.nextById;
exports.prevById = getById.prevById;
exports.getByText = getByText.getByText;
exports.getByTypeahead = getByTypeahead.getByTypeahead;
exports.getComputedStyle = getComputedStyle.getComputedStyle;
exports.getEventTarget = getEventTarget.getEventTarget;
exports.getParent = getScrollParent.getParent;
exports.getScrollParent = getScrollParent.getScrollParent;
exports.getScrollParents = getScrollParent.getScrollParents;
exports.isEditableElement = isEditableElement.isEditableElement;
exports.isHTMLElement = isHtmlElement.isHTMLElement;
exports.getPlatform = platform.getPlatform;
exports.isApple = platform.isApple;
exports.isDom = platform.isDom;
exports.isFirefox = platform.isFirefox;
exports.isIPhone = platform.isIPhone;
exports.isIos = platform.isIos;
exports.isMac = platform.isMac;
exports.isSafari = platform.isSafari;
exports.isTouchDevice = platform.isTouchDevice;
exports.query = query.query;
exports.queryAll = query.queryAll;
exports.nextTick = raf.nextTick;
exports.raf = raf.raf;
exports.MAX_Z_INDEX = MAX_Z_INDEX;
